<template>
  <div>
    <h3>Monederos A&B</h3>
    <uv-data-table
      :config="config"
      :data="monederos"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    ></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Movimientos monedero">
      <formMonedero
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </formMonedero>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import formMonedero from "./MonederosRestauranteForm.vue";
import Cliente from "../../../clases/Cliente.js";
export default {
  name: "MonederoCRUD",
  components: {
    modal,
    uvDataTable,
    formMonedero,
  },
  props: [],
  data() {
    return {
      //data_clientes:[],
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      Categories: [],
      editData: [],
      products: [],
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "Monedero", Type: "Desc" },
        buttons: [
          {
            text: "Movimientos Monedero",
            icon: "lni lni-pencil-alt",
            buttonId: "movimientosMonedero",
            require: true,
          },
        ],
        fields: [
          {
            title: "Apellidos",
            dataName: "Apellidos",
            text: "Apellidos",
            value: "Apellidos",
          },
          {
            title: "Nombres",
            dataName: "Nombres",
            text: "Nombres",
            value: "Nombres",
          },
          {
            title: "Total Monedero",
            dataName: "Monedero",
            text: "Total Monedero",
            value: "Monedero",
            format: (row) => {
              let text = row["Monedero"]
                ? this.$pgsHelper.formatNumber(row["Monedero"].Saldo) + " P"
                : "Sin monedero";
              return text;
            },
          },

          {
            title: "Total MXN",
            dataName: "Monedero",
            text: "Total MXN",
            value: "Monedero",
            format: (row) => {
              let text = row["Monedero"]
                ? this.$pgsHelper.formatNumber(row["SaldoConversion"]) + " MXN"
                : "Sin monedero";
              return text;
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "movimientosMonedero") {
        this.formIndex++;
        this.editMode = true;
        let prodEdit = this.$pgsHelper.getById(
          this.monederos,
          "Id",
          idSelected[0]
        );
        this.editData = prodEdit;
        this.showModal = true;
      }
      if (buttonId == "deleteCupon") {
        this.deleteCupon(idSelected[0]);
      }
    },
    successData(data) {
      this.$pgsHelper.log(data);
      let sendData = {
        FechaCreacion: Date.now(),
        Mayoristas: {},
        Departamentos: {},
        Moneda: "USD",
        Precio: parseFloat(data.costoCupon),
        Nombre: data.nombre,
        Tipo: "Cupon",
        Activo: data.status,
        UsosVenta: data.cuponesIlimitados ? null : data.cantidad,
      };
      /*let catalogo = [];
        data.productos.forEach(element => {
            catalogo.push({
                    Id: element.id,
                    CantVenta: element.CantidadCupon,
                    MndaContable: "USD",
                    MndaMayorista: "USD",
                    Tipo:element.Tipo,
                    Origen: element.Origen,
                    PrcoContable: element.PrecioContable,
                    PrcoMayorista: element.PrecioMayorista,
                    }
            );  
        });*/
      sendData.Catalogo = data.productos;
      sendData.Mayoristas[data.mayorista] = true;
      sendData.Departamentos[this.MainDepartamento] = true;

      this.$pgsHelper.log(sendData);
      if (data.Id == "" || !data.Id) {
        this.createCupon(sendData);
      } else {
        sendData.Id = data.Id;
        this.editCupon(sendData);
      }
    },
    createCupon(datos) {
      this.$swal({
        title: "¿Deseas agregar este cupón?",
        text: "Podras editarlo cuando quieras",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-crearCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteCupon(id) {
      let datos = { Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar este cupón?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-eliminarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El cupón se elimino correctamente",
              "El cupón se elimino correctamente",
              "success"
            );
            this.getCupons();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editCupon(datos) {
      this.$swal({
        title: "¿Deseas editar el cupón?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Cupones-editarCuponMayorista", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El cupón se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCupons();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    getCuponById(code) {
      let itemIndex = this.$_.findIndex(this.global_cupon, { id: code });
      if (itemIndex >= 0) {
        return this.global_cupon[itemIndex];
      }

      return false;
    },
  },
  computed: {
    global_cupon() {
      let cup_prod = [
        {
          CantidadCupon: 1,
          Nombre: "Guante de Golf para Hombre-CC93",
          PrecioContable: 22,
          PrecioMayorista: 20,
          Origen: "-MLtKZvkWu8Ew6t9piKl",
          compId: "BHyZIJjGXIRlxsTVnJo0_-MLtKZvkWu8Ew6t9piKl",
          id: "BHyZIJjGXIRlxsTVnJo0",
        },
      ];
      let cupon = [
        {
          id: "papanoel",
          Nombre: "BDAY2020",
          Mayorista: "BestDay",
          Ilimitado: true,
          Cantidad: 2,
          CostoCupon: 1244,
          PrecioVenta: 1000,
          Productos: cup_prod,
          Estatus: true,
        },
        {
          id: "navidad",
          Nombre: "MAJESTIC2020",
          Mayorista: "Majestic Hotel",
          Ilimitado: false,
          Cantidad: 2,
          CostoCupon: 1244,
          PrecioVenta: 2000,
          Productos: cup_prod,
          Estatus: false,
        },
      ];

      //let sortReservations = this.$_.orderBy(prod,'Orden','asc');

      return cupon;
    },
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cliente) => {
        cliente.SaldoConversion = cliente.Monedero ? cliente.Monedero.Saldo : 0;
        cliente.SaldoConversion = cliente.SaldoConversion * 1;
        clientes.push(cliente);
      });

      return clientes;
    },
    monederos() {
      let monederos = [];
      this.data_clientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          monederos.push(element);
        }
      });
      return monederos;
    },
  },
  watch: {},
  mounted() {
    // this.getClientes();
  },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
};
</script>
